export function getShortName(fullName = "-") {

    if (fullName == "") { return "-"; };
    //get text of input
    let text = String(fullName);
    //Replace breakpoints for spaces.
    text = text.replace(/\r?\n/g, " ");
    //Replace multiple spaces for only one
    text = text.replace(/[ ]+/g, " ");
    //Remove spaces of begin and end
    text = text.replace(/^ /, "");
    text = text.replace(/ $/, "");
    //split text by spaces
    text = text.split(" ");
    switch (text.length) {
        case 0:
            return "-";
            break;
        case 1:
            return text[0].substr(0, 1).toUpperCase();
            break;
        default:
            return text[0].substr(0, 1).toUpperCase() + text[1].substr(0, 1).toUpperCase();
    }
}

export function trimMobileNumber(contacts) {

    let contactsWithoutWhitespace = [];

    contacts.map(function (contact) {
        contactsWithoutWhitespace.push({
            "displayName": contact.displayName,
            "mobileNumber": contact.mobileNumber.replace(/ /g, "")
        });
    });

    return removeContactsWithoutNumber(contactsWithoutWhitespace);
}

export function uniqueBy(arr, key) {
    return arr.reduce((acc, ci) => {
        if (!ci.hasOwnProperty(key))
            throw new Error(`key with name ${key} does not exists in array`);
        return [...acc.filter(i => i[key] !== ci[key]), ci];
    }, []);
}


export function b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
}


function removeContactsWithoutNumber(contacts){
    return contacts.filter(
        contact => 
            contact.mobileNumber != "" && 
            contact.mobileNumber != null && 
            contact.mobileNumber != "undefined" &&
            contact.mobileNumber != "Not_Number" &&
            contact.displayName != "" &&
            contact.displayName != "null" &&
            contact.displayName != "undefined"
        );
}